import { render, staticRenderFns } from "./RecentSessionsWidget.vue?vue&type=template&id=275c445e&scoped=true"
import script from "./RecentSessionsWidget.vue?vue&type=script&lang=js"
export * from "./RecentSessionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c445e",
  null
  
)

export default component.exports